import React, { useContext } from "react"
import { View } from "react-native"
import { ScrollView } from "react-native-gesture-handler"
import { Divider } from "react-native-paper"
import {
    Menu,
    MenuOption,
    MenuOptions,
    MenuTrigger,
    renderers,
} from "react-native-popup-menu"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import FontAwesome6 from "react-native-vector-icons/FontAwesome6"
import { theme } from "../../theme/theme"
import { DimensionsContext } from "../../utils/mobileUtils"
import TextM from "../text/TextM"

export const MenuM = ({
    buttonComponent,
    items,
    style,
    renderer = renderers.ContextMenu,
    name = null,
    center = false,
    optionStyle,
    optionHeight = 60,
    useFA6 = false,
    disabled = false,
}) => {
    const insets = useSafeAreaInsets()

    const dimensions = useContext(DimensionsContext)

    return (
        <Menu style={style} renderer={renderer} name={name}>
            <MenuTrigger
                disabled={disabled}
                style={{ ...(disabled ? { opacity: 0.5 } : {}) }}
            >
                {buttonComponent}
            </MenuTrigger>
            <MenuOptions
                customStyles={{
                    optionsWrapper: {
                        paddingBottom:
                            renderer === renderers.SlideInMenu
                                ? insets.bottom
                                : 0,
                        maxHeight: dimensions?.height / 2,
                    },
                    optionWrapper: {
                        width:
                            dimensions?.width > 800
                                ? dimensions?.width / 2
                                : dimensions?.width - 40,
                        height: optionHeight,
                    },
                }}
            >
                <ScrollView>
                    {items?.map((i, index) => {
                        switch (i.type) {
                            case "title":
                                return (
                                    <React.Fragment key={index}>
                                        <TextM
                                            fontWeight={"ExtraBold"}
                                            fontSize={18}
                                            color={theme.colors.primary}
                                            style={{
                                                marginTop: 15,
                                                marginBottom: 10,
                                                paddingLeft: 10,
                                                textAlign: center
                                                    ? "center"
                                                    : "left",
                                            }}
                                            wrap
                                        >
                                            {i?.title}
                                        </TextM>
                                    </React.Fragment>
                                )
                            case "divider":
                                return <Divider key={index} />
                            default:
                                return (
                                    !i?.masked && (
                                        <MenuOption
                                            key={index}
                                            style={{
                                                alignSelf: center
                                                    ? "center"
                                                    : "flex-start",
                                                backgroundColor:
                                                    i?.highlighted &&
                                                    theme.colors.lightMore,
                                                width: "100%",
                                                opacity: i?.disabled ? 0.5 : 1,
                                                ...optionStyle,
                                            }}
                                            onSelect={i?.onPress}
                                            disabled={i?.disabled}
                                        >
                                            <View
                                                style={{
                                                    flexDirection: "row",
                                                    alignItems: "center",
                                                    justifyContent: center
                                                        ? "center"
                                                        : "flex-start",
                                                    flex: 1,
                                                }}
                                            >
                                                {i?.icon && (
                                                    <View
                                                        style={{
                                                            width: 30,
                                                            alignItems:
                                                                "center",
                                                            justifyContent:
                                                                "center",
                                                        }}
                                                    >
                                                        {useFA6 || i?.useFA6 ? (
                                                            <FontAwesome6
                                                                style={{
                                                                    paddingVertical: 5,
                                                                    marginHorizontal: 4,
                                                                }}
                                                                name={i?.icon}
                                                                size={18}
                                                                color={
                                                                    theme.colors
                                                                        .grey
                                                                }
                                                            />
                                                        ) : (
                                                            <FontAwesome5
                                                                style={{
                                                                    paddingVertical: 5,
                                                                    marginHorizontal: 4,
                                                                }}
                                                                name={i?.icon}
                                                                size={18}
                                                                color={
                                                                    theme.colors
                                                                        .grey
                                                                }
                                                            />
                                                        )}
                                                    </View>
                                                )}
                                                {i?.leftComponent
                                                    ? i?.leftComponent
                                                    : null}
                                                {i?.title && (
                                                    <View
                                                        style={{
                                                            maxWidth: 400,
                                                            flex: 1,
                                                        }}
                                                    >
                                                        <TextM
                                                            fontSize={14}
                                                            fontWeight={
                                                                "Medium"
                                                            }
                                                            style={{
                                                                paddingHorizontal: 10,
                                                                paddingVertical: i?.subtitle ? 2 : 5,
                                                                textAlign:
                                                                    center
                                                                        ? "center"
                                                                        : "left",
                                                            }}
                                                            wrap
                                                        >
                                                            {i?.title}
                                                        </TextM>
                                                        {i?.subtitle && (
                                                            <TextM
                                                                fontSize={11}
                                                                color={theme.colors.warning}
                                                                style={{
                                                                    paddingHorizontal: 10,
                                                                    paddingBottom: 5,
                                                                    textAlign:
                                                                        center
                                                                            ? "center"
                                                                            : "left",
                                                                }}
                                                                wrap
                                                            >
                                                                {i?.subtitle}
                                                            </TextM>
                                                        )}
                                                    </View>
                                                )}
                                                {i?.component && i?.component}
                                            </View>
                                        </MenuOption>
                                    )
                                )
                        }
                    })}
                </ScrollView>
            </MenuOptions>
        </Menu>
    )
}
